import React from 'react';
import ReactDOM from 'react-dom';
import { addContainer, removeElement } from '../_utils/dom';
import OModal from './Modal';
var setup = {
    containerId: 'confirm-modal-container'
};
var showConfirm = function (title, message) {
    addContainer(setup.containerId);
    var hide = function () { return removeElement(setup.containerId); };
    return new Promise(function (resolve) {
        var modal = (React.createElement(OModal, { visible: true, hideCloseButton: true, okText: "Confirm", clickOutside: false, titleText: title, bodySlot: message, onOk: function () {
                resolve(true);
                hide();
            }, onCancel: function () {
                resolve(false);
                hide();
            }, bodyMinHeight: 50 }));
        ReactDOM.render(modal, document.getElementById(setup.containerId));
    });
};
export default showConfirm;
